import Fuse from "fuse.js";

const MAX_RESULTSET_LENGTH = 100;

const normalize = (s: unknown = ""): string =>
  String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const filterItems = <T>(items: T[], filter?: string | null): T[] => {
  const q = normalize(filter);
  if (!q) return items.slice(0, MAX_RESULTSET_LENGTH);

  const fuse = new Fuse(items, {
    isCaseSensitive: false,
    shouldSort: true,
    threshold: 0.35,
    distance: 120,
    ignoreLocation: true,
    minMatchCharLength: q.length,
    keys: ["label", "value"],

    getFn: (obj, path) =>
      normalize((obj as Record<string, unknown>)[path as string]),
  });

  return fuse
    .search(q)
    .slice(0, MAX_RESULTSET_LENGTH)
    .map((r) => r.item);
};

export default filterItems;
